export const getColIdFromEmail = email => {
  if (email) {
    return email.replace(/[^a-z0-9]/gi, '')
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/store/user/getColIdFromEmail.ts